import { TextInput, useNotify, useRefresh } from "react-admin";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { Grid } from "@mui/material";
import { settings } from "app";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const RejectModal = ({
  request,
  label = "Откажи",
  titleContent = "Отказ на Алумни профил",
  successMessage = "Успешна редакция на статус",
}) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSent = async data => {
    const confirmData = {
      reason: data.reason,
    };
    await dataProvider.customRequest(request, confirmData, "PUT");
    refresh();
    notify(successMessage, { type: "success" });
  };

  return (
    <FormModal
      titleContent={titleContent}
      onConfirm={handleSent}
      startIcon={<ThumbDownIcon />}
      titleButton={label}
      btnStyle={{
        width: "max-content",
        backgroundColor: theme => theme.palette.error.main,
        color: theme => theme.palette.white.main,
        "&:hover": {
          bgcolor: theme => theme.palette.error.dark,
        },
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
      }}
      variant="text"
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <TextInput
            source="reason"
            label="Причина"
            sx={settings.style.textAria}
            variant="outlined"
            fullWidth
            multiline
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default RejectModal;
